import React from 'react'

import { connect } from 'react-redux'
import { Container, Card } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { userCan } from 'src/store/user/userActions'
import { route } from 'src/utils/routes'
import { IState } from 'src/store'

import Error401 from 'src/pages/Error/401.page'
import ChannelService from 'src/services/ChannelService'
import { IChannel } from 'src/services/types/channel'

import Header from 'src/components/Layout/Header/Header'
import NotFound from 'src/components/Error/NotFound'
import ChannelForm from 'src/components/Channel/ChannelForm'

const channelService = new ChannelService()

interface IProps extends RouteComponentProps {
  user: any
  userCan: (permission: string) => boolean

  match: any
}

const ChannelUpdate: React.FC<IProps> = ({ userCan, match, history }) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [channel, setChannel] = React.useState<IChannel>()

  const _isMounted = React.useRef<boolean>(false)
  React.useEffect(() => {
    _isMounted.current = true
    return () => {
      _isMounted.current = false
    }
  }, [])

  React.useEffect(() => {
    if (userCan('update_channel')) {
      channelService
        .fetchById(match.params.id)
        .then((channel) => _isMounted.current && setChannel(channel))
        .finally(() => _isMounted.current && setIsLoading(false))
    }
  }, [userCan, match.params.id])

  if (!userCan('update_channel')) return <Error401 />

  return (
    <>
      <Header
        title={
          isLoading
            ? 'Channel'
            : channel
            ? `${channel.name}`
            : 'Channel not found'
        }
        backText="Channels"
        onBack={() => history.push(route('channels'))}
      />
      <div className="page-container">
        <Container>
          <Card>
            <Card.Header>
              <Card.Title>Channel Details</Card.Title>
            </Card.Header>
            <Card.Body className="pt-0">
              {!isLoading && channel ? (
                <ChannelForm
                  type="update"
                  channel={channel}
                  updateChannel={(updatedValues) => {
                    setChannel({ ...channel, ...updatedValues })
                  }}
                />
              ) : null}

              {!isLoading && !channel ? (
                <div className="my-5">
                  <NotFound summary="Channel not found" />
                </div>
              ) : null}

              {isLoading && (
                <div className="d-flex justify-content-center py-5">
                  <figure className="spinner primary" />
                </div>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default connect((state: IState) => ({ user: state.user }), { userCan })(
  withRouter(ChannelUpdate)
)
